var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUserName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.000732422C5.37328 0.000732422 0 5.37295 0 12.0002C0 18.6275 5.37275 23.9997 12 23.9997C18.6278 23.9997 24 18.6275 24 12.0002C24 5.37295 18.6278 0.000732422 12 0.000732422ZM12 3.58871C14.1927 3.58871 15.9696 5.3661 15.9696 7.55779C15.9696 9.75001 14.1927 11.5269 12 11.5269C9.80831 11.5269 8.03145 9.75001 8.03145 7.55779C8.03145 5.3661 9.80831 3.58871 12 3.58871ZM11.9974 20.8624C9.81042 20.8624 7.80743 20.0659 6.2625 18.7476C5.88615 18.4266 5.66898 17.9559 5.66898 17.462C5.66898 15.2392 7.46798 13.4603 9.69129 13.4603H14.3098C16.5336 13.4603 18.3257 15.2392 18.3257 17.462C18.3257 17.9565 18.1096 18.4261 17.7328 18.7471C16.1884 20.0659 14.1848 20.8624 11.9974 20.8624Z",
    fill: "#F66524"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserName);
export default __webpack_public_path__ + "static/media/IconUserName.2259e223d16a7bdd046b1e184ad5039d.svg";
export { ForwardRef as ReactComponent };